import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/instagram-retina.png'
import _imports_1 from '@/assets/twitter-retina.png'
import _imports_2 from '@/assets/youtube-retina.png'


const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"social-links\"><a href=\"https://www.instagram.com/forechamp/\" target=\"_blank\" title=\"Follow ForeChamp on Instagram\"><img src=\"" + _imports_0 + "\" alt=\"Instagram icon\"></a><a href=\"https://twitter.com/forechamp\" target=\"_blank\" title=\"Follow ForeChamp on Twitter\"><img src=\"" + _imports_1 + "\" alt=\"Twitter icon\"></a><a href=\"https://www.youtube.com/channel/UCA8_5Nlh1anevEP2cjOWJCA\" target=\"_blank\" title=\"Subscribe to ForeChamp on YouTube\"><img src=\"" + _imports_2 + "\" alt=\"YouTube icon\"></a></div>", 1)
const _hoisted_3 = { class: "footer-links no-list" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Home", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Blog", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Podcast", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/blog" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, { to: "/podcast" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("span", null, "©" + _toDisplayString(_ctx.currentYear) + " ForeChamp. All Rights Reserved.", 1)
  ]))
}